import { HTMLAttributes, ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { Container, getSpacingToken } from '@optimus-web/core';

export interface ContentContainerProps extends HTMLAttributes<HTMLElement> {
    children: ReactNode;
    condensed?: boolean;
    fill?: boolean;
    maxWidth?: '640px' | '960px' | 'none';
    align?: 'left' | 'center' | 'right';
}

export const ContentContainer = ({
    children,
    condensed = false,
    maxWidth,
    align = 'center',
    fill = false,
    ...other
}: ContentContainerProps) => {
    const theme = useTheme();

    return (
        <Container
            maxWidth={maxWidth}
            padding={condensed ? '100' : ['300', '200']}
            desktopUp={{
                padding: condensed ? '200' : ['400', '300'],
                height: fill ? `calc(100% - ${getSpacingToken('400')({ theme }) * 2}px)` : undefined,
            }}
            align={align}
            position="relative"
            height={fill ? `calc(100% - ${getSpacingToken('300')({ theme }) * 2}px)` : undefined}
            {...other}
        >
            {children}
        </Container>
    );
};

export const SmallContentContainer = (props: Exclude<ContentContainerProps, 'maxWidth'>) => (
    <ContentContainer maxWidth="640px" {...props} />
);

export const LargeContentContainer = (props: Exclude<ContentContainerProps, 'maxWidth'>) => (
    <ContentContainer maxWidth="960px" {...props} />
);
